/* CEJ的单元重点单词页面 */
/*  Author: qichen */
/* create: 2019/03/10 */
/*  modified: wanfeng 2019/03/12 */
<template>
  <div class="flex-center flex-column mainbody">
    <div id="header">
      <div class="header-title-word"><span style="fontSize: 20px">{{ lang.data_raw | multiReplace([['{name}',
        Data.data_raw.u_name]]) }}</span></div>
      <div class="bg"><img src="../../../static/images/PeasonalizedTarget-background.png"></div>
    </div>

    <div class="text-border-panel">
      <div class="maintext">
        <span class="flex-row-center orange-bold" v-html="Data.unit_info.base_info.unit_name"> </span>
        <p v-html="lang.unit_name"></p>
        <div v-if="Data.tips" style="text-indent: 2px;font-size: 15px" v-html="addDiv(Data.tips)"></div>
      </div>
    </div>
    <div class="header-panel" v-if="Data.unit_info.course_info">
      <div class="headertitle"> {{ lang.course_info }} </div>
    </div>
    <div class="text-border-panel" v-if="Data.unit_info.course_info">
      <div class="maintext">
        <div class="course-info">
          <span v-if="Data.unit_info.base_info.course_name">
            <template v-html="getProcessedHtml(lang['course_name_info_0'], [[`{name}`, Data.data_raw.u_name],['{course_name}', Data.unit_info.base_info.course_name], ['{tea_name}', Data.data_raw.tea_name]])"></template>
          </span>
          <span v-else>
            {{ lang.course_name_info_2 |  multiReplace([['{name}',
        Data.data_raw.u_name]])}}</span>
        <template v-html="getProcessedHtml(lang['course_name_info_3'], [['{tea_name}', Data.data_raw.tea_name], ['{name}', Data.data_raw.u_name]])"></template>
        </div>
        <div class="resource-list" id="key_word">
          <div class="course-info" v-for="lesson in Data.unit_info.course_info">
            <div class="course-name"> {{ lesson.course_name }}</div>
            <div class="word-mean1" v-for="word in lesson.word_in_lesson">
              <a :href="'/resource/word_v2/' + word.id + tailUrl"><span class="orange-bold"> {{ word.word_name }}
                </span></a>
              <span class="orange-bold">{{ word.meaning }} </span>
            </div>
            <div class="word-mean1" v-for="word in lesson.word_grasp_lesson">
              <a :href="'/resource/word_v2/' + word.id + tailUrl"><b> {{ word.word_name }} </b></a>
              <span class="blue-bold">{{ word.meaning }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="header-panel" v-if="Data.unit_info.word_out_set">
      <div class="headertitle"> {{ lang.word_out_set | multiReplace([['{name}',
        Data.data_raw.u_name]])}} </div>
    </div>

    <div class="text-border-panel" v-if="Data.unit_info.word_out_set">
      <div class="maintext">
        <p>{{ lang.word_out_set_tips | multiReplace([['{name}',
        Data.data_raw.u_name]])}}</p>
        <div class="resource-list" id="key_word">
          <div class="word-mean" v-for="word in Data.unit_info.word_out_set">
            <a :href="'/resource/word_v2/' + word.id + tailUrl"><span class="orange-bold">{{ word.word_name }}</span></a>
            <span class="orange-bold">{{ word.meaning }} </span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import BaseVue from '@/components/BaseVue'
import Utils from "@nat/heibao-utils"
export default {
  name: 'WordUnitTemplateV2',
  extends: BaseVue,
  data() {
    return {
      Data: {
        tips: '',
        data_raw: { u_name: "", tea_name: "" },
        unit_info: {
          base_info: {
            level_index: 0,
            unit_index: 1,
            unit_name: "",
            unit_type: "now",
            version: "CEJ4.0",
            course_name: ""
          },
        }
      },
      // unit_info: {
      //   base_info: {
      //     level_index: 1,
      //     unit_index: 16,
      //     unit_name: "第十六单元 动物 Animals",
      //     unit_type: "now",
      //     version: "CEJ4.0",
      //     course_name:""},
      //   course_info: [
      //   {
      //     course_name: "第一课 我的宠物兔 My Pet Rabbit",
      //     word_in_lesson: [{real_id: "12227",id: "8E46037E3632F1135DAC7F5D8A9566CD",word_name: "cage",meaning: "笼子"},
      //     {real_id: "13308",id: "73A33A57A7C5FF49B74D1EA0908784A1",word_name: "pet",meaning: "宠物"}],
      //     word_grasp_lesson: [{real_id: "13423",id: "2D6F93575CEDFB6D19749C06DE118481",word_name: "rabbit",meaning: "兔子"}]
      //   },
      //   {
      //     course_name: "第二课 快乐学语音 sh Fun with Phonics sh",word_in_lesson: "",
      //     word_grasp_lesson: [{real_id: "12671",id: "545DB93D0C0BAA794DC9FBA0277CBB0E",word_name: "fish",meaning: "鱼"},
      //     {real_id: "13594",id: "84BFCBD519C03AA7BCE5633C7B957929",word_name: "shark",meaning: "鲨鱼"},
      //     {real_id: "14842",id: "3964F5D0CD43985A2C414086F3619451",word_name: "ship",meaning: "船"}]
      //   },
      //   {
      //     course_name: "第三课 Emma最喜欢的动物 Emma's Favorite Animal",
      //     word_in_lesson: "",
      //     word_grasp_lesson: [{real_id: "12779",id: "47CF1E417F7B2A17958052A2420380FD",word_name: "goat",meaning: "山羊"},
      //     {real_id: "13050",id: "63A29CC53DB508CD543FB788C1CE1BC7",word_name: "lion",meaning: "狮子"},
      //     {real_id: "13828",id: "34213A45C7803A4E3165224F725CBE3C",word_name: "tail",meaning: "尾巴"}]}
      //     ],
      //   word_out_set: [{real_id: "12989",id: "7E7C976FA1DFB3988EA0BC38D8C3DC27",word_name: "jungle",meaning: "丛林"},
      //    {real_id: "13828",id: "34213A45C7803A4E3165224F725CBE3C",word_name: "tail1",meaning: "尾巴1"},
      //     {real_id: "13828",id: "34213A45C7803A4E3165224F725CBE3C",word_name: "tail2",meaning: "尾巴2"}]}
      // }
    }
  },
  computed: {
    tailUrl: function () {
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: async function () {
    // let data_id = this.$route.params.id
    let data_id = this.$route.query.uid
    let unit_type = this.$route.query.unit_type
    await this.getLang()
    document.title = this.lang.WordUnitTemplateV2Title
    let lang = Utils.getQuery('metalang') || localStorage.getItem('currLang')
    //在BaseVue里面增加配置 APPOINT_API: 'http://101.200.43.74:8181/app_opt/',
    let url = this.GATEWAY_ORIGINAL + 'bigdata/unit_knowledge/query_unit_word_list?uid=' + data_id + '&unit_type=' + unit_type
    url = `${url}&appkey=magic&timestamp=${new Date().getTime()}&metalang=${lang}`
    this.url_params = this.$route.fullPath.split('?')[1]
    let that = this;
    // 因为我这接口正常代码是10000和其他的0不一样，所以单独写个获取函数
    //10002 用户三个月内没有上CEJ4.0+CEJ5.0的课程
    this.Data.data_raw.u_name = this.lang.stu
    $.ajax({
      type: "GET",
      url: url,
      timeout: this.TIMEOUT,
      success: function (data) {
        if (typeof (data) === 'string') data = JSON.parse(data)
        if (data.error_code == 10000) {
          that.Data = data.ret.data
        } else {
          let u_name = that.Data.data_raw.u_name
          that.Data.tips = that.getProcessedHtml(that.lang.error_tips, [['{name}', u_name]])
          console.log('Error data: ' + data)
        }
      }
    })
  },
  methods: {
    getProcessedHtml(value, params) {
      let processedString = this.$options.filters.multiReplace(value, params);
      return processedString;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/resource/WordUnitV2.vue